export function datadogEnv(host: string) {
  const matches = host
    .toLowerCase()
    .match(/(\w+)(?::\d+|\.aptitudedev\.com|\.aptitudemarketplace\.com)$/);

  if (Array.isArray(matches)) {
    if (matches[1] === 'www') {
      return 'prod';
    } else {
      return matches[1];
    }
  } else {
    return 'unknown';
  }
}
